(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ip-seo-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const content = document.getElementById("ip-read-more-content");
    const toggleBtn = document.getElementById("ip-read-more-toggle");

    toggleBtn.addEventListener("click", function () {
      content.classList.toggle("collapsed");
      toggleBtn.textContent = content.classList.contains("collapsed") ? "Mehr lesen" : "Weniger lesen";
    });
  });


  } catch(e) { console.error(e); }
})();
})();
